import {CurrencyPipe} from '@angular/common';
import {Injectable} from '@angular/core';

@Injectable()
export class formatNumberService {

  constructor(
    private currencyPipe: CurrencyPipe
  ) {
  }

  formatBrlUsa(num: any) {
    return num.replace('.', '|').replace(',', '.').replace('|', ',');
  }

  formatBrlUsa2(num: any) {
    return num.replace('.', '').replace(',', '.');
  }

  formatUsaBrl(num: any) {
    return num.replace(',', '|').replace('.', ',').replace('|', '.');
  }

}



// WEBPACK FOOTER //
// ./src/providers/util/formatNumber.service.ts